import { useQuery } from '@tanstack/react-query';
import { getMyTeamsInOrgOptions } from '../generated/api/@tanstack/react-query.gen.js';
import { useAuthStore } from '../store';

/**
 * Teams the current user belongs to within their active organization.
 * Returns `[]` while unauthenticated or while the query is in flight.
 */
export function useMyTeams() {
  const orgId = useAuthStore((s) => s.user?.organizationId ?? null);
  const query = useQuery({
    ...getMyTeamsInOrgOptions({ path: { orgId: String(orgId) } }),
    select: (res) => res.data,
    enabled: orgId != null,
    staleTime: 5 * 60 * 1000,
  });
  if (query.isError) console.error('useMyTeams: failed to load teams', query.error);
  return query;
}
